import React from 'react';
import {SidebarBanner} from 'app/components/banner/SidebarBanner';
import {useHistory} from 'react-router';

const NoDeviceBanner = ({closeSidebar}) => {
  const history = useHistory();

  const primaryAction = {
    label: 'Geräteverwaltung öffnen',
    action: () => {
      closeSidebar();
      history.push('/my/following/devices');
    },
  };
  const secondaryAction = null;
  const text = 'Aktuell hast du kein Gerät für Push-Benachrichtigungen registriert.';

  return <SidebarBanner primaryAction={primaryAction} secondaryAction={secondaryAction} text={text} show={true} />;
};

export {NoDeviceBanner};
